import { Link, useSearchParams } from 'react-router-dom'

const REASONS: Record<string, { heading: string; body: string }> = {
  expired: {
    heading: 'Lien expiré',
    body: 'Votre lien de connexion a expiré. Demandez-en un nouveau.',
  },
  missing_token: { heading: 'Lien invalide', body: 'Le lien semble incomplet. Réessayez.' },
  oauth_state_mismatch: {
    heading: 'Connexion interrompue',
    body: 'La connexion Google a été interrompue. Réessayez.',
  },
  oauth_failed: {
    heading: 'Échec de la connexion Google',
    body: 'Impossible de finaliser la connexion.',
  },
  email_not_verified: {
    heading: 'Email non vérifié',
    body: 'Vérifiez votre adresse Google avant de réessayer.',
  },
  account_conflict: {
    heading: 'Conflit de compte',
    body: 'Cette adresse est associée à un autre compte Google. Contactez le support.',
  },
}

export default function AuthError() {
  const [params] = useSearchParams()
  const reason = params.get('reason') ?? 'unknown'
  const r = REASONS[reason] ?? { heading: 'Erreur', body: 'Une erreur est survenue.' }
  return (
    <div className="auth-shell">
      <div className="auth-frame">
        <div className="auth-card">
          <div className="err-mark" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="32" height="32">
              <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="1.4" />
              <path d="M12 7v6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
              <circle cx="12" cy="16.5" r=".9" fill="currentColor" />
            </svg>
          </div>
          <p className="eyebrow">Connexion impossible</p>
          <h1 className="auth-title">{r.heading}</h1>
          <p className="auth-sub">{r.body}</p>
          <div className="auth-actions">
            <Link to="/auth/sign-in" className="btn-primary btn-full">
              Retour à la connexion
            </Link>
            {reason === 'account_conflict' && (
              <a href="mailto:support@liste-naissance.app" className="btn-ghost btn-full">
                Contacter le support
              </a>
            )}
          </div>
          <p className="auth-fine code-line">
            Code: <code>{reason}</code>
          </p>
        </div>
      </div>
    </div>
  )
}
